import { createSlice } from "@reduxjs/toolkit";

const onBoardingSlice = createSlice({
  name: "onboardingData",
  initialState: {},

  reducers: {
    openSideDrawer: (state, action) => {
      return { ...action.payload };
    },
    closeSideDrawer: (state, action) => {
      return {};
    },
  },
});

export const { openSideDrawer, closeSideDrawer } = onBoardingSlice.actions;

export default onBoardingSlice.reducer;
